<section class="hero">
  <div class="container">
    <div class="hero__content">
      <h1 class="hero__title">Transforma tu comunicación digital con Zapphira.ai</h1>
      <p class="hero__subtitle">
        Agente conversacional de IA generativa para tu sitio web y WhatsApp. 
        Automatiza consultas, gestiona reservas y potencia tus capacitaciones.
      </p>
      <div class="hero__actions">
        <button class="hero__demo-btn">Ver demostración</button>
        <button class="hero__contact-btn">Contactar ventas</button>
      </div>
    </div>
    
    <div class="hero__visual">
      <div class="hero__chat-window">
        <div class="hero__chat-header">
          <div class="hero__chat-header-content"></div>
        </div>
        
        <div class="hero__chat-messages">
          <div class="hero__chat-message hero__chat-message--bot">
            <p>Hola, soy Zapphira. ¿En qué puedo ayudarte hoy?</p>
          </div>
          <div class="hero__chat-message hero__chat-message--user">
            <p>Quiero información sobre integración con mi sitio web</p>
          </div>
          <div class="hero__chat-message hero__chat-message--bot">
            <p>¡Claro! La integración con tu sitio web es muy sencilla. Puedes implementar nuestro widget personalizable con solo unas líneas de código. ¿Te gustaría ver una demostración?</p>
          </div>
        </div>
        
        <div class="hero__chat-input">
          <div class="hero__chat-input-field"></div>
          <div class="hero__chat-input-send"></div>
        </div>
      </div>
    </div>
  </div>
</section>